
export var costValidator = {
    costCenter: {
        required: true,
        description: "成本中心不能为空"
    },
    wbs: {
        required: true,
        description: "WBS不能为空"
    },
    rate: {
        required: true,
        description: "分摊预算百分比不能为空"
    },
    partnerName: {
        required: false,
        description: "财务部业务伙伴不能为空"
    },
    partnerEmail: {
        required: false,
        description: "电子邮件地址不能为空",
//      regExp: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
//      regExpMsg: "邮箱格式不正确"
    }
}


// WEBPACK FOOTER //
// ../scripts/validators/costValidator.js